import { useEffect, type RefObject } from 'react'

/**
 * 바깥 클릭·Esc 로 닫기. 와이어프레임은 같은 패턴을 5번 복붙했고(§11-1-6),
 * 단일 클릭 핸들러에서 `data-stop` 으로 전파를 수동 차단하다가 드롭다운 안 클릭이
 * 삼켜지는 함정을 4번 반복했다(§13-1). 한 곳으로 모으고 Esc 도 같이 처리한다.
 *
 * ⚠ 원자 쪽 드롭다운(필터·정렬 알약)이 같은 것을 필요로 하면 이 파일을 공유해라. 복제하지 마라.
 */
export function useOutsideClick(
  ref: RefObject<HTMLElement | null>,
  open: boolean,
  onClose: () => void,
): void {
  useEffect(() => {
    if (!open) return

    const onPointerDown = (event: MouseEvent) => {
      const target = event.target
      if (target instanceof Node && ref.current?.contains(target)) return
      onClose()
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }

    document.addEventListener('pointerdown', onPointerDown)
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('pointerdown', onPointerDown)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [ref, open, onClose])
}
